// Keep in sync with BasicCommaList.js
const MULTI_DATAPOINT_REGEX = /(\((.+?),(.+?)(,(.+?))?\))+/g;

const MULTI_JSON_REGEX = /({.+?})+/g;

const MAX_NUM_DATASETS = 20;

// Keep in sync with templateOverrides.js on backend
export function applyTemplateOverrides(chart, templateOverrides, isVersion3) {
  // Applies template overrides within the chart object.
  if (!templateOverrides) {
    return;
  }
  const { title, labels } = templateOverrides;

  // Parse top level attributes
  if (title) {
    if (isVersion3) {
      chart.options = chart.options || {};
      chart.options.plugins = chart.options.plugins || {};
      chart.options.plugins.title = chart.options.plugins.title || {};
      chart.options.plugins.title.display = true;
      chart.options.plugins.title.text = title.split('\n');
    } else {
      chart.options = chart.options || {};
      chart.options.title = chart.options.title || {};
      chart.options.title.display = true;
      chart.options.title.text = title.split('\n');
    }
  }
  if (labels) {
    chart.data.labels = labels.split(',');
  }

  // Parse supported dataset attributes
  for (const attribute of ['backgroundColor', 'borderColor', 'label', 'value']) {
    for (let num = 1; num <= MAX_NUM_DATASETS; num++) {
      const key = `${attribute}${num}`;
      let value = templateOverrides[key];
      if (value) {
        if (typeof value === 'string' && !value.startsWith('rgb') && !value.startsWith('hsl')) {
          const splits = value.split(',');
          if (splits.length > 1) {
            value = splits;
          }
        }
        const dataset = chart.data.datasets[num - 1];
        if (!dataset) {
          throw new Error(
            `Dataset ${num} does not exist, but you are trying to set ${attribute} on it. Make sure your chart template has at least ${num} datasets.`,
          );
        }
        dataset[attribute] = value;
      }
    }
  }

  // Parse data
  const datas = [];
  for (let num = 1; num <= MAX_NUM_DATASETS; num++) {
    const data = templateOverrides['data' + num];
    if (data) {
      datas.push(data);
    } else {
      break;
    }
  }
  datas.forEach((data, idx) => {
    if (chart.data.datasets[idx]) {
      let matches;
      if (data.startsWith('(')) {
        // Complex datapoints
        matches = data.matchAll(MULTI_DATAPOINT_REGEX);
        if (!matches) {
          return new Response('Error parsing data - invalid format', {
            status: 400,
          });
        }
        chart.data.datasets[idx].data = [];
        [...matches].forEach((match) => {
          const x = match[2];
          const y = match[3];
          const z = match[5];
          const datapoint = z ? { x, y, z } : { x, y };
          chart.data.datasets[idx].data.push(datapoint);
        });
      } else if (data.startsWith('{')) {
        matches = data.matchAll(MULTI_JSON_REGEX);
        if (!matches) {
          return new Response('Error parsing data - invalid format', {
            status: 400,
          });
        }
        chart.data.datasets[idx].data = [];
        [...matches].forEach((match) => {
          const datapoint = JSON.parse(match[0]);
          chart.data.datasets[idx].data.push(datapoint);
        });
      } else if (data.startsWith('[')) {
        chart.data.datasets[idx].data = JSON.parse(data);
      } else {
        // Simple datapoints
        chart.data.datasets[idx].data = data.split(',');
      }
    }
  });
}
